/*
|--------------------------------------------------------------------------
| Utilities: Fetch: HTML
|--------------------------------------------------------------------------
*/

/**
 * Fetch HTML will listen for a click event and use the data attributes on
 * the item to retrieve html content from a url and put it into a dom container.
 * @memberof utilities.fetch
 * @namespace utilities.fetch.html
 * @inner
 */
__gh__webApp.utilities.fetch.html = {

	/**
	 * Initialize
	 *
	 * @memberof utilities.fetch.html
	 * @method init
	 */
	"init": function() {
		this.bindEvents();
		this.loadAllHTML();
	},

	/**
	 * Get the html and insert it into a DOM
	 *
	 * @memberof utilities.fetch.html
	 * @method get
	 * @param {object} options
	 * @param {string} options.dom - dom selector for the container to insert the html
	 * @param {string} options.url - url to get the html from
	 */
	"get" : function(options) {
		var commonJS	= __gh__webApp.common,
			dom 		= (options.dom) 		? options.dom 		: null,
	    	url 		= (options.url) 		? options.url 		: null,
	    	callbacks 	= (options.callbacks)	? options.callbacks	: null;

		if(!url){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.html.get",message:"Missing url."});
			return;
		}
		if(!dom){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.html.get",message:"Missing dom."});
			return;
		}

		url = commonJS.noCacheURL(url);

	    $.ajax({
	        'async': true,
	        'global': false,
	        'url': url,
	        'dataType': "html",
	        'success': function (html) {
	           $(dom).html(html);
	           	//Run callback function
				if (callbacks){
					__gh__webApp.common.callArrayOfFunctions(callbacks);
				}
	        }
	    });
	},
	
	
	/**
	 * Loads html for all items on a page with the correct data attributes
	 *
	 * @memberof utilities.fetch.html
	 * @method loadAllHTML
	 * @param {object} options
	 * @param {string} options.dom - dom selector for the container to insert the html
	 * @param {string} options.url - url to get the html from
	 * @example
	 * &lt;div id="example" data-gh-fetch-html-dom="#example" data-gh-fetch-html-url="http://example.com/html"&gt;&lt;/div&gt;
	 */
	 "loadAllHTML": function() {
		var fetchHTML = this.get;
		//Auto load html content
		$("[data-gh-fetch-html-loaded=false]").each(function(){
			var $dom  	= $(this);

			fetchHTML({
				'dom'		: $(this).data('gh-fetch-html-dom'),
				'url'		: $(this).data('gh-fetch-html-url'),
				"callbacks"	: $(this).data("gh-fetch-html-callbacks")
			});

			//Only load html once.
			if(!$dom.data("gh-fetch-html-loaded")){
				$dom.attr("data-gh-fetch-html-loaded",true);
			}


	  	});
	},

	/**
	 * Bind the UI events
	 *
	 * @memberof utilities.fetch.html
	 * @method bindEvents
	 * @example <caption>Fetch HTML on click</caption>
	 * 	&lt;div id="container"&gt;&lt;/div&gt;&lt;a href="#" data-gh-fetch-html-url="http://redesign.gatehousemedia.com/jason/targetHTML.html" data-gh-fetch-html-dom="#container"&gt;Test&lt;/a&gt;
	 *
	 */
	"bindEvents": function() {
		var fetchHTML = this.get;
		//Load html content on click
	    $(document).on("click", "a[data-gh-fetch-html-url]", function(event){
		    event.preventDefault();
			fetchHTML({
				'dom'		: $(this).data('gh-fetch-html-dom'),
				'url'		: $(this).data('gh-fetch-html-url'),
				//"callbacks"	: $(this).data("gh-fetch-html-callbacks").split(","),
			});
		});
  	},
};
